import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useApolloClient, useQuery } from "react-apollo";

import { Button, Icon } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { toast } from "react-toastify";
import { useCurrentUser } from "../utils/hooks";

import { useAuthorization } from "./Authorization";

import { UPDATE_ORDER_MUTATION } from "../graphql/Orders/Orders.graphql";
import { ALL_SYSTEM_CODES_QUERY } from "../graphql/SystemCodes/SystemCodes.graphql";

class CustomVerifyRouteError extends Error {}

const VerifyRouteButton = ({ order }) => {
  const client = useApolloClient();
  const { data: user } = useCurrentUser();
  const isAuthed = useAuthorization(["ADMIN", "DISP"]);
  const [isVerifiable, setIsVerifiable] = useState(false);
  const { data, loading } = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        Category_in: ["Order", "ELD"],
        CodeName_in: ["OrderStatus", "ELDStatus"],
        CodeId_in: ["RV", "IMP", "NE"]
      }
    }
  });

  useEffect(() => {
    if (data?.SystemCodes && !isVerifiable) {
      const importedStatus = data.SystemCodes.find(s => s.CodeId === "IMP");
      setIsVerifiable(
        isAuthed && order.StatusRecIdRef === importedStatus.RecId
      );
    }
  }, [data, isAuthed, isVerifiable, order.StatusRecIdRef]);

  const handleVerify = async () => {
    try {
      if (!/^\d+$/.test(order.ShippersNumber)) {
        throw new CustomVerifyRouteError(
          "Invalid Shippers Reference Number. Value must not be blank and must contain only numbers."
        );
      }
      const { SystemCodes } = data;
      const ELDStatus = SystemCodes.find(s => s.CodeId === "NE");
      const Status = SystemCodes.find(s => s.CodeId === "RV");
      await client.mutate({
        mutation: UPDATE_ORDER_MUTATION,
        variables: {
          data: {
            StatusRecIdRef: Status.RecId,
            ELDStatusRecIdRef: ELDStatus.RecId,
            VerifiedByRecIdRef: user.RecId.toString()
          },
          where: {
            RecId: order.RecId
          }
        },
        refetchQueries: ["SINGLE_ORDER_QUERY"]
      });
    } catch (err) {
      if (err instanceof CustomVerifyRouteError) {
        toast.warn(err.message);
      }
      console.log(err.message);
    }
  };

  return (
    isVerifiable && (
      <Button
        color="warning"
        size="small"
        state={loading ? "loading" : ""}
        onClick={handleVerify}
      >
        <Icon>
          <FontAwesomeIcon icon="certificate" />
        </Icon>
        <span>Verify Route</span>
      </Button>
    )
  );
};
VerifyRouteButton.propTypes = {
  order: PropTypes.object
};
export default VerifyRouteButton;
